import angular from "angular";

import lodash from "./lodash";

class RequestService {

  constructor(_, $log, $q){

    this._ = _;
    this.$log = $log;
    this.$q = $q;

    this.requests = {};
    this.blockRequests = false;
  }

  add(reqId, config) {
    //console.log(reqId,config);
    if (!this.blockRequests || config.isException) {
      this.cancel(reqId);
      this.requests[reqId] = this.$q.defer();
      //console.log("add request id: ", reqId);
      //console.log("RS: ADD    : ", Object.keys(requests).length);
      return this.requests[reqId];
    }
    else {
      return 1;
    }

  }

  remove(reqId) {

    if (this.requests[reqId]) {
      delete this.requests[reqId];
    }
    //console.log("RS: REMOVE : ", Object.keys(requests).length);
  }

  cancel(reqId) {
    if (this.requests[reqId]) {
      var request = this.requests[reqId];
      request.promise.isGloballyCanceled = true;
      request.resolve();
    }
  }

  cancelAll() {
    //console.log("RS: PENDING: ", Object.keys(requests).length);

    this.blockRequests = true;
    for (var url in this.requests) {
      this.requests[url].resolve();
    }
    this.blockRequests = false;
    //console.log("RS: PENDING: ", Object.keys(requests).length);
  }

}

RequestService.$inject = ["_", "$log", "$q"];

export default angular.module("services.RequestService",[lodash])
  .service("RequestService",RequestService)
  .name;



// WEBPACK FOOTER //
// ./src/ui/app/services/RequestService.js